import { trackSelfDescribingEvent } from '@snowplow/browser-tracker';
import { getCookie } from './utils';
import { SNOWPLOW_EVENTS } from '../constants';

export const trackHelpSupportClick = (
  isChatBotEnabled,
  userDetails = {},
  description = ""
) => {
  try {
    const {
      uuid = "",
      userId = "",
      patientId = "",
      pmEntityID = "",
    } = userDetails || {};

    const platform = getCookie("platform") || "WEB";
    const appVersion = getCookie("versionCode") || "";
    const osVersion = getCookie("osVersion") || "";
    const sessionId = getCookie("mb-s-sessionId") || "";

    const timestamp = new Date().toISOString();
    const isLoggedIn = Boolean(uuid);

    trackSelfDescribingEvent({
      event: {
        schema: SNOWPLOW_EVENTS.HELP_SUPPORT_CLICK.SCHEMA,
        data: {
          mbuuid: String(uuid),
          mbuserid: String(userId),
          platform,
          osversion: osVersion,
          patientid: String(patientId),
          timestamp,
          appversion: appVersion,
          pmentityid: String(pmEntityID),
          screenName: SNOWPLOW_EVENTS.HELP_SUPPORT_CLICK.SCREEN_NAME,
          description,
          "login-state": String(isLoggedIn),
          "mb-s-sessionId": sessionId,
          isChatBotEnabled: Boolean(isChatBotEnabled),
        },
      }
    });
  } catch (error) {
    console.error("Error tracking HELP_SUPPORT_CLICK event");
  }
};
